var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.url,"download":""}},[_vm._v("Download")])
}
var staticRenderFns = []

export { render, staticRenderFns }